import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";

export default function SecondApartament() {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);

  const customUrl1 = "9"; // First URL (image)
  const customUrl2 = "9"; // Floor number
  const customUrl3 = "7"; // Floor number
  const vrPath = "vr-9-3"; // Dynamic VR directory

  // Detect mobile devices
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Close hover effect when clicking outside (only on mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };

    if (isMobile && isClicked) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsHovered(true); // First tap highlights the apartment
        setIsClicked(true);
      } else {
        navigate("/navigate-floor", { state: { customUrl1, customUrl2, vrPath, customUrl3 } }); // Second tap navigates
      }
    } else {
      navigate("/navigate-floor", { state: { customUrl1, customUrl2, vrPath, customUrl3 } }); // Desktop: direct navigation
    }
  };

  return (
    <img
      ref={imageRef}
      className={`absolute w-[8vw] right-[41.1vw] top-[31vw] cursor-pointer transition-opacity duration-100 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
      src="/images/click/clickable-images/Floors/Direct-floors/clickable-floors/SeventhFloor/SecondApartament-Green.png"
      alt="Second Apartament"
      onMouseEnter={() => !isMobile && setIsHovered(true)} // Hover effect for desktop
      onMouseLeave={() => !isMobile && setIsHovered(false)} // Remove hover effect for desktop
      onClick={handleClick} // Click-to-hover for mobile
    />
  );
}
